import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AssignmentRouting from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/assignment-routing'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'assignment_routing',
          component: AssignmentRouting,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
